module.exports = __webpack_public_path__ + "static/Truck8-7c876d594f085043d0aa9ef10b721865.png";